<template lang="pug">
.content
  VacationDialog
  slot
</template>

<script>
import VacationDialog from './vacation/VacationDialog'

export default {
  name: 'GlobalWrapper',
  components: { VacationDialog },
}
</script>

<style lang="sass" scoped>
.content
  width: 100%
</style>
